export default "__VITE_ASSET__Bm11VH5K__"